import { useMemberInfoQuery } from "src/hooks/queries/useMemberInfoQuery";

export const Main = () => {
  const { memberInfo } = useMemberInfoQuery();

  return <div>{memberInfo?.member.id}</div>;
};
